import { client } from './utils';

export const getUsageAnalyticsDashboard = () =>
    client.get('/account/usage-analytics/dashboard').then((res) => res.data);

export const getUsageAnalyticsMonthly = (monthStart) =>
    client.get(`/account/usage-analytics/monthly/${monthStart}`).then((res) => res.data);

export const getUsageHistoryFilters = () =>
    client.get('/account/usage-analytics/usage-history-filters').then((res) => res.data);

export const getEventCallComparison = (identifier, month) =>
    client
        .get('/account/usage-analytics/event-call-comparison', { params: { identifier, month } })
        .then((res) => res.data);

export const exportUsageAnalytics = (payload) =>
    client
        .post('/account/usage-analytics/export', payload, { responseType: 'blob' })
        .then((res) => {
            const disposition = res.headers['content-disposition'];
            let filename = 'usage-export.xlsx';
            if (disposition) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match) filename = match[1].replace(/['"]/g, '');
            }
            const url = URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        })
        .catch(async (err) => {
            let message = 'Eksporto klaida';
            if (err.response?.data instanceof Blob) {
                try {
                    const text = await err.response.data.text();
                    const json = JSON.parse(text);
                    message = json.message || json.debugMessage || message;
                } catch {
                    // blob wasn't JSON — keep default
                }
            }
            throw new Error(message);
        });

export const requestHistoricalExport = (payload) =>
    client.post('/account/usage-analytics/historical-export/request', payload).then((res) => res.data);

export const pollExportStatus = (jobId) =>
    client
        .get(`/account/usage-analytics/historical-export/${jobId}/status`)
        .then((res) => res.data);

export const downloadHistoricalExport = (jobId, filename) =>
    client
        .get(`/account/usage-analytics/historical-export/${jobId}/download`, { responseType: 'blob' })
        .then((res) => {
            const disposition = res.headers['content-disposition'];
            let name = filename || 'usage-export.xlsx';
            if (disposition) {
                const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                if (match) name = match[1].replace(/['"]/g, '');
            }
            const url = URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = name;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        })
        .catch(async (err) => {
            let message = 'Eksporto klaida';
            if (err.response?.data instanceof Blob) {
                try {
                    const text = await err.response.data.text();
                    const json = JSON.parse(text);
                    message = json.message || json.debugMessage || message;
                } catch {
                    // blob wasn't JSON — keep default
                }
            }
            throw new Error(message);
        });
